	/**
	 * @description
	 *  Modelo de un checkout sobre un pedido.
	 *
	 * @see gigot-backend/Models/Orders/OrderEvent.cs
	 */

	export class OrderCheckout {

		public invoiceTypeLabel: string;
		public shippingAmount: number;
		public excemptTaxAmount: number;
		public ivaAmount: number;
		public iibbPercentage: number;
		public iibbPercentageAmount: number;
		public otherTaxes: number;
		public taxAndProfitAmount: number;
		public subTotalAmount: number;
		public totalAmount: number;
		public differenceToPay : number;
	
		/**
		 * @description
		 *	Construye un checkout de order vacía. Nótese que no
		 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
		 *	generales de construcción son:
		 *
		 *      - Campos 'array' se definen como [].
		 *      - Campos 'boolean' se definen como 'false'.
		 *      - Campos 'Date' se definen como 'undefined'.
		 *      - Campos 'enum' se definen como 'undefined'.
		 *      - Campos 'number' se definen como 'undefined'.
		 *      - Campos 'string' se definen como '' (cadena vacía).
		 *      - Campos 'object' se definen llamando a su propio método #empty().
		 *      - Campos de la superclase se definen al igual que campos 'object'.
		 *      - Campos genéricos se definen como 'undefined'.
		 *		- Campos recursivos se definen como 'undefined'.
		 *
		 * @returns
		 *	Un Checkout de Order vacío.
		 */
		public static empty(): OrderCheckout {
			const orderCheckout: OrderCheckout = new OrderCheckout();
			orderCheckout.invoiceTypeLabel = '';
			orderCheckout.shippingAmount = undefined;
			orderCheckout.excemptTaxAmount = undefined;
			orderCheckout.ivaAmount = undefined;
			orderCheckout.iibbPercentage = undefined;
			orderCheckout.iibbPercentageAmount = undefined;
			orderCheckout.otherTaxes = undefined;
			orderCheckout.taxAndProfitAmount = undefined;
			orderCheckout.subTotalAmount = undefined;
			orderCheckout.totalAmount = undefined;
			orderCheckout.differenceToPay  = undefined;
			return orderCheckout;
		}
	
	}
	